import { Injectable } from '@angular/core';
import { LocalDbService } from './localDb.service';

@Injectable({
    providedIn: 'root'
})
export class TranslateService {

    language = 'en';
    private translations: any = {};

    constructor(private localDb: LocalDbService) {
        this.localDb.localGet('language').then((savedLang: string) => {
            if (savedLang) {
                this.language = savedLang;
                this.loadTranslations();
            }
        });

    }

    setLanguage(lang: string) {
        this.language = lang;
        this.localDb.localPost('language', lang).then(() => {
            this.loadTranslations();
        });
    }

    async loadTranslations() {
        if (this.language === 'en') {
            this.translations = {};
        } else {
            const translationsModule = await import(`../translate/${this.language}.json`);
            this.translations = translationsModule.default;

        }
    }

    translate(key: string): string {
        if (this.language === 'en') return key;
        return this.translations[key] || key;
    }

    translateObjList(objList) {
        for (let item of objList) {
            if (this.language != "en") {
                item.name = this.translations[item.value];
            }

        }
    }
}